<template>
    <el-col
      :span="$vuetify.display.width >= 1500 ? 24 : 24"
      class="width-100-p p-2"
    >
      <div class="row m-0 p-2 bg-me-primary border-color-light rounded-4">
        <el-col style="align-content: center;" :span="24">
          <el-radio-group
            v-model="mapTheme"
            text-color="#ffff"
            fill="#234B49"
            :class="$vuetify.display.width < 750 ? 'width-100-p' : ''"
          >
            <el-radio-button
              class="start-period all-group-by text-center"
              label="light"
              :class="$vuetify.display.width < 750 ? 'width-50-p' : ''"
            >
              {{
                "Light"
              }}
            </el-radio-button>
            <el-radio-button
              class="site-group-by text-center end-period"
              label="dark"
              :class="$vuetify.display.width < 750 ? 'width-50-p' : ''"
            >
              Dark
            </el-radio-button>
          </el-radio-group>
        </el-col>
        <el-col
          :span="24"
          class="mt-3 px-2"
          v-loading="loading"
          :element-loading-spinner="svg"
          element-loading-svg-view-box="-10, -10, 50, 50"
          element-loading-background="rgba(122, 122, 122, 0.8)"
        >
          <div
            :id="mapTheme == `light` ? `map` : `map-dark`"
            style="z-index: 1"
            :style="[
                  $vuetify.display.width >= 1500
                    ? { height: 635 + 'px' }
                    : $vuetify.display.width >= 500
                    ? { height: 600 + 'px' }
                    : { height: 340 + 'px' },
                ]"
          ></div>
  
          <div ref="popupContainer"></div>
        </el-col>
      </div>
    </el-col>
  </template>
  
  <script>
  import UserService from "../../../services/user.service";
  import L from "leaflet";
  import "leaflet/dist/leaflet.css";
  import "leaflet.markercluster/dist/MarkerCluster.css";
  import "leaflet.markercluster/dist/MarkerCluster.Default.css";
  import "leaflet.markercluster";
  import PopupContent from "./PopupGroupByDistance";
  import { createApp } from "vue";
  import ElementPlus from "element-plus";

  
  export default {
    props: {
      chargerDistributionProp: {
        type: Array,
        default: null,
      },
      loadingProp: {
        type: Boolean,
        default: false,
      },
      stateProp: {
        type: String,
        default: null,
      },
      filterProp: {
        type: Object,
        default: null,
      },
      mapDataProp: {
        type: Object,
        default: null,
      },
      findInMapProp: {
         type: Array,
         default: () => [null, null],
       },
   
    },
    components: {
      // eslint-disable-next-line vue/no-unused-components
      PopupContent,
    },
    watch: {
   
      filterProp: {
        handler: function (newVal) {
          this.customer_id = newVal.customer_id;
          this.state = newVal.state == "All" ? "" : newVal.state;
          // console.log(newVal);
          this.fetchGroupByDistance();
        },
        deep: true,
      },
      mapDataProp: {
        handler: function (newVal) {
            this.setMapData(newVal);
        },
        deep: true,
      },
      findInMapProp: {
         handler: function (newVal) {
           if (newVal[0] != null && newVal[1] != null) {
             console.log('newVal', newVal);
             this.mapOption.center = [newVal[0], newVal[1]];
             // Zoom to the largest scale (maximum zoom level)
             const maxZoom = 18; // Maximum zoom level for OpenStreetMap
             this.map.flyTo(this.mapOption.center, maxZoom);
           }
         },
         deep: true,
       },
    
    },
    data() {
      return {
        mapTheme: "light",
  
        loading: false,
        state: null,
        map: null,
        markerClusterGroup: null,
        mapOption: {
          url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
          attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
          zoom: 2,
          center: [-37.8136, 144.9631],
        },
        mapOptions: {
          scrollWheelZoom: false,
        },
        SiteDataList: [],
        popup: null,
        popupData: {
          site_name: "",
          state: "",
          chargers_count: 0,
          chargers_capacity_sum: 0,
        },
        customer_id: [],
        circle: null,   // Circle layer
        circles: [],    // Array to store multiple circles
        // mapHeight: 400,
      };
    },
    mounted() {
      // this.fetchGroupByDistance();
      // Remove the initMap call here since it will be called after data is fetched
      // this.initMap();
    },
    methods: {
        setMapData(newData){
            // Ensure data is properly formatted
            this.loading = true;
        
        
        if(!newData){
          this.SiteDataList = [];
          this.mapOption.center = [-37.8136, 144.9631]; // Default to Melbourne
          this.initMap();
          this.loading = false;
          return;
        }

        if (newData && Array.isArray(newData)) {
          this.SiteDataList = newData;
          
        } else if (Array.isArray(newData)) {
          this.SiteDataList = newData;
          
        } else {
          this.SiteDataList = [];
          console.warn("Expected array data but received:", typeof newData);
          
        }
        
        this.total_items = this.SiteDataList.length;
        if (this.total_items > 0) {
            // Find first item with valid coordinates from central_site
            const firstValidItem = this.SiteDataList.find(item => {
                const centralSite = item.central_site || item;
                return centralSite.lat != null && centralSite.lat !== 0 && 
                       centralSite.lng != null && centralSite.lng !== 0;
            });
            
            if (firstValidItem) {
                const centralSite = firstValidItem.central_site || firstValidItem;
                this.mapOption.center = [
                    centralSite.lat,
                    centralSite.lng
                ];
            } else {
                this.mapOption.center = [-37.8136, 144.9631]; // Default to Melbourne
            }
        } else {
            this.mapOption.center = [-37.8136, 144.9631]; // Default to Melbourne
        }

        this.initMap();
        this.loading = false;
        },
        addCircle(lat, lng, radius, unit) {
                if (unit == 'miles') {
                    radius = radius * 1.60934 * 1000; // Convert miles to kilometers
                } else {
                    radius = radius * 1000; // Convert kilometers to meters
                }

                // console.log("add circle", lat, lng, radius, unit);
                
                const circle = L.circle([lat, lng], {
                    color: 'blue',
                    fillColor: '#30f',
                    fillOpacity: 0.1,
                    radius: radius, // Convert km to meters
                }).addTo(this.map);

                circle.bindPopup(`Center at (${lat}, ${lng}) with radius ${radius / 1000} ${unit} `);
                return circle;
            },
        initMap() {
            if (this.map) {
                // Clean up existing circles
                if (this.circles && this.circles.length > 0) {
                    this.circles.forEach(circle => {
                        if (circle && this.map.hasLayer(circle)) {
                            this.map.removeLayer(circle);
                        }
                    });
                    this.circles = [];
                }
                this.map.remove();
            }
            
            // Ensure we have valid center coordinates
            if (!this.mapOption.center || 
                (this.mapOption.center[0] === 0 && this.mapOption.center[1] === 0)) {
                this.mapOption.center = [-37.8136, 144.9631]; // Default to Melbourne
            }
            
            this.map = L.map(this.mapTheme == 'light' ? "map" : "map-dark", {
            zoomControl: true,
            zoom: 1,
            zoomAnimation: false,
            fadeAnimation: true,
            markerZoomAnimation: true,
            }).setView(this.mapOption.center, this.mapOption.zoom);
            L.tileLayer(this.mapOption.url, {
            attribution: this.mapOption.attribution,
            }).addTo(this.map);
            this.markerClusterGroup = L.markerClusterGroup();
            this.addMarkers();
            this.map.addLayer(this.markerClusterGroup);
            this.fitMapToMarkers();
            
        },

        fitMapToMarkers() {
            if (!this.map || !this.markerClusterGroup) {
                return;
            }
            const bounds = this.markerClusterGroup.getBounds();
            if (!bounds.isValid()) {
                return;
            }
            this.map.fitBounds(bounds, {
                padding: [48, 48],
                maxZoom: 8,
            });
        },

        addMarkers() {
            // Clear existing markers and circles
            if (this.markerClusterGroup) {
                this.markerClusterGroup.clearLayers();
            }
            
            // Store circles for cleanup
            this.circles = [];
            
            // Ensure SiteDataList is an array
            if (!Array.isArray(this.SiteDataList)) {
                this.SiteDataList = [];
                return;
            }
            
            this.SiteDataList.forEach((item) => {
                // Handle new data structure with central_site and nearby_sites
                const centralSite = item.central_site || item;
                
                if (centralSite.lat == null) centralSite.lat = 0;
                if (centralSite.lng == null) centralSite.lng = 0;
                
                // Remove circle creation - only show markers
                // const circle = this.addCircle(centralSite.lat, centralSite.lng, 0.1, 'kms');
                // this.circles.push(circle);
                
                // Add marker for the central site only (represents the entire group)
                L.marker([centralSite.lat, centralSite.lng], {
                    icon: this.getCustomIcon(item.total_sites_in_group)
                })
                .on("click", (e) => this.showPopup(e, centralSite))
                .addTo(this.markerClusterGroup);
                
                // Remove individual nearby site markers since they have the same coordinates
                // and would create duplicate markers at the same location
                // if (item.nearby_sites && item.nearby_sites.length > 0) {
                //     item.nearby_sites.forEach((site) => {
                //         if (site.lat != null && site.lng != null) {
                //             L.marker([site.lat, site.lng], {
                //                 icon: this.getCustomIcon(site) // Individual site marker
                //             })
                //             .on("click", (e) => this.showPopup(e, site))
                //             .addTo(this.markerClusterGroup);
                //         }
                //     });
                // }
            });
        },

        getCustomIcon(value) {
          // Handle both old and new data structures
          let markerValue = value;
          
          const color = this.getColorFromValue(markerValue);
          return L.icon({
            iconUrl: this.getIconUrl(color),
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowUrl:
              "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
            shadowSize: [41, 41],
            shadowAnchor: [12, 41],
          });
        },
        getIconUrl(color) {
          const markerSvg = 
          `<svg width="31" height="43" viewBox="0 0 31 43" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_2200_5329)">
          <path d="M15.4999 8.44043C11.5599 8.44043 8.35986 11.6804 8.35986 15.6404C8.35986 19.6104 11.5599 22.8404 15.4999 22.8404C19.4399 22.8404 22.6399 19.6004 22.6399 15.6404C22.6399 11.6804 19.4399 8.44043 15.4999 8.44043Z" fill="white"/>
          <path d="M15.5 0.5C23.77 0.5 30.5 7.29 30.5 15.65C30.5 18.15 29.88 20.63 28.72 22.81L15.5 42.12L2.28 22.81C1.11 20.62 0.5 18.14 0.5 15.64C0.5 7.29 7.23 0.5 15.5 0.5ZM15.5 8.44C11.56 8.44 8.36 11.68 8.36 15.64C8.36 19.61 11.56 22.84 15.5 22.84C19.44 22.84 22.64 19.6 22.64 15.64C22.64 11.68 19.44 8.44 15.5 8.44Z" fill="${color}" stroke="white"/>
          </g>
          <defs>
          <clipPath id="clip0_2200_5329">
          <rect width="31" height="43" fill="white"/>
          </clipPath>
          </defs>
          </svg>`;
          return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
            markerSvg
          )}`;
        },
        getColorFromValue(value) {
          let r, g, b;

          if (value <= 1) {
            // Level 2
            r = 244;
            g = 215;
            b = 97;
          } else if (value <= 4) {
            // Level 4
            r = 120;
            g = 190;
            b = 32;
          } else {
            // For values > 4
            r = 20;
            g = 96;
            b = 84;
          }

          return `rgb(${r},${g},${b})`;
        },
  
        showPopup(e, marker) {
            if (this.popup) {
            this.popup.remove();
            }

            // Prepare popup data based on the marker type
            let popupData = {};
            
            // Check if this is a central site marker or nearby site marker
            const centralSiteItem = this.SiteDataList.find(item => {
                const centralSite = item.central_site || item;
                return centralSite.lat === marker.lat && centralSite.lng === marker.lng;
            });
            
            if (centralSiteItem) {
                // This is a central site marker
                const centralSite = centralSiteItem.central_site || centralSiteItem;
                popupData = {
                    central_site_group_id: centralSiteItem.group_id || 'Unknown',
                    central_site_title: centralSite.site_name || 'Unknown Site',
                    central_site_full_name: centralSite.full_name || 'Unknown',
                    central_site_address: centralSite.address_comment || 'Unknown',
                    central_site_postcode: centralSite.postcode || '',
                    nearby_sites: centralSiteItem.nearby_sites || centralSiteItem.sites_in_range || []
                };
            } else {
                // This is a nearby site marker
                popupData = {
                    central_site_title: marker.site_name || 'Unknown Site',
                    central_site_full_name: marker.full_name || 'Unknown',
                    central_site_group_id: marker.group_id || 'Unknown',
                    central_site_address: marker.address_comment || 'Unknown',
                    central_site_postcode: marker.postcode || '',
                    nearby_sites: [marker]
                };
            }

            this.popupData = popupData;
            // console.log("popupData", this.popupData);
            
            const popupContainer = document.createElement("div");
            const appInstance = createApp(PopupContent, {
            popupData: this.popupData,
            }).use(ElementPlus);
            appInstance.mount(popupContainer);
            this.map.flyTo(e.latlng, this.map.getZoom());
            this.popup = L.popup()
            .setLatLng(e.latlng)
            .setContent(popupContainer)
            .openOn(this.map);
        },
  
      fetchGroupByDistance() {
        this.loading = true;
        UserService.ChargerMapGroupByDistance(11, 100)
          .then(
            (response) => {
              if(!response.data){
                this.SiteDataList = [];
                this.mapOption.center = [-37.8136, 144.9631]; // Default to Melbourne
                this.initMap();
                return;
              }
              // console.log("map data", response.data);
              
              // Handle the response structure: response.data.data contains the array
              if (response.data && response.data.data && Array.isArray(response.data.data)) {
                this.SiteDataList = response.data.data;
              } else if (Array.isArray(response.data)) {
                this.SiteDataList = response.data;
              } else {
                this.SiteDataList = [];
                console.warn("Expected array data but received:", typeof response.data);
              }
              
              this.total_items = this.SiteDataList.length;
              if (this.total_items > 0) {
                  // Find first item with valid coordinates from central_site
                  const firstValidItem = this.SiteDataList.find(item => {
                      const centralSite = item.central_site || item;
                      return centralSite.lat != null && centralSite.lat !== 0 && 
                             centralSite.lng != null && centralSite.lng !== 0;
                  });
                  
                  if (firstValidItem) {
                      const centralSite = firstValidItem.central_site || firstValidItem;
                      this.mapOption.center = [
                          centralSite.lat,
                          centralSite.lng
                      ];
                  } else {
                      this.mapOption.center = [-37.8136, 144.9631]; // Default to Melbourne
                  }
              } else {
                  this.mapOption.center = [-37.8136, 144.9631]; // Default to Melbourne
              }

              this.initMap();
            },
            (error) => {
              this.loading = false;
              console.log(error);
              if (error.response.status == 401) {
                this.$router.push({
                  path: "/",
                  query: {
                    error: "Unauthorized",
                  },
                });
              }
              return;
            }
          )
          .catch((error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
              return;
            }
          })
          .finally(() => (this.loading = false));
      },

    },
  };
  </script>
  
  
  